/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Toast_Delete_ErrorInputs */

const es_components_credentials_toast_delete_error = /** @type {(inputs: Components_Credentials_Toast_Delete_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar la credencial`)
};

const en_components_credentials_toast_delete_error = /** @type {(inputs: Components_Credentials_Toast_Delete_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete the credential`)
};

/**
* | output |
* | --- |
* | "Failed to delete the credential" |
*
* @param {Components_Credentials_Toast_Delete_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_toast_delete_error = /** @type {((inputs?: Components_Credentials_Toast_Delete_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Toast_Delete_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_toast_delete_error(inputs)
	return en_components_credentials_toast_delete_error(inputs)
});
export { components_credentials_toast_delete_error as "components.credentials.toast.delete.error" }